<template>
  <div class="xscontainer jsjiesh">
    <p style="color: red">说明:请输入你参加认证时提供的姓名、邮箱地址</p>
    <div class="divbeijing mydiv" >
      <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" style="margin-top: 1.5rem;">
        <el-form-item label="姓名" prop="xingming">
          <el-input v-model="ruleForm.xingming"  autocomplete="off" @keyup.enter.native="queryZs('ruleForm')"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="youxiang">
          <el-input v-model="ruleForm.youxiang"  autocomplete="off" @keyup.enter.native="queryZs('ruleForm')"></el-input>
        </el-form-item>
      </el-form>
      <div class="lldd" style="margin-top: -3rem">
        <div class="resetBTn" @click="resetForm('ruleForm')">重置</div>
        <div class="queryBtn"  @click="queryZs('ruleForm')">查询</div>
      </div>
    </div>
    <div class="kkerwere" style="margin-top: 1rem;" v-for="(item,index) in zhengshus">
      <p class="biaoti2">【证书-{{index+1}}】</p>
      <div class="llxs">
        <img class="zskkk"  :src="item.zspicture" />
        <table>
          <tbody>
          <tr>
            <td class="td_1">姓名</td>
            <td class="td_2">{{item.xingming}}</td>
          </tr>
          <tr>
            <td class="td_1">证书类型</td>
            <td class="td_2" v-if="item.zslx == 'tongren'">统认</td>
            <td class="td_2" v-if="item.zslx == 'danxiang'">单项</td>
          </tr>
          <tr v-if="item.zslx == 'tongren'">
            <td class="td_1">星数</td>
            <td class="td_2">{{item.xingshu}}</td>
          </tr>
          <tr v-if="item.zslx == 'danxiang'">
            <td class="td_1">相关方向</td>
            <td class="td_2">{{item.xgfx}}</td>
          </tr>
          <tr>
            <td class="td_1">证书名称</td>
            <td class="td_2">{{item.zsmc}}</td>
          </tr>
          <tr>
            <td class="td_1">证书编号</td>
            <td class="td_2">{{item.zscode}}</td>
          </tr>
          <tr>
            <td class="td_1">发证日期</td>
            <td class="td_2">{{item.startsj}}</td>
          </tr>
          <tr>
            <td class="td_1">发证机构</td>
            <td class="td_2">国际数据治理协会</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64';
export default {
  name: 'HomePage',
  data() {
    return {
      ruleForm: {
        xingming:'',
        youxiang:''
      },
      rules: {
        xingming: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        youxiang: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
      },
      zhengshus:[],
      fwcishu:0
    }
  },

  created() {
    this.tongji('证书查询');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.zhengshus = [];
    },
    queryZs(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this;
          this.$ajax
              .get(this.GLOBAL.sys_addr + '/personzhengshu/tPersonZhengshu/list?_t='+new Date().getTime()+'&xingming='+this.ruleForm.xingming+'&youxiang='+Base64.encode(this.ruleForm.youxiang)+'&column=id&order=asc&pageNo='+0+'&pageSize='+100)
              .then(function (response) {
                if (response.data.code == 200) {
                  debugger
                  that.zhengshus  = response.data.result.records;
                  if(that.zhengshus.length == 0){
                    alert("不存在该用户的信息，请检查是否填写正确");
                  }
                } else {
                  that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
                }
              });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style  scoped>
.mydiv {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  padding: 3rem 20%;
}

.el-form-item {
  margin-bottom: 3rem;
}

.lldd {
  width: 100%;
  display: flex;
  justify-content: center;
  gap:2rem;
}

::v-deep .el-form-item__label {
  font-weight: bold;
  color: #4e83c5 !important;
}

.zskkk {
  width: 20rem;
  height: 28rem;
}

.llxs {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  gap:2rem;
  justify-content: center;
}

table {
  width: 100%;
  margin: 20px auto;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

th, td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #4e83c5;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.td_1 {
  width: 30%;
  color: #4e83c5;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
}

.td_2 {
  width: 70%;
  text-align: center;
  font-size: 1rem;
}

.kkerwere{
  width: 100%;
}
</style>
